import table from './table'

const places =
{
    ...table,
    helmet :
    {
        title : 'Lieux' ,
        metas : []
    },
    empty  : 'Aucun lieu trouvé',
    search : 'Rechercher un lieu ...' ,
    title  : 'Lieux'
};

export default places ;
